var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 34,
    viewBox: "0 0 117 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_313_2854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.9115 32.8078L81.9154 13.4042L83.4398 32.8078H92.0791L88.0752 2.00842H78.8354L74.5232 20.4879L70.2117 2.00842H60.9718L56.9677 32.8078H65.5916L67.1317 13.4042L71.1357 32.8078H77.9115Z",
    fill: "#00046A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.707 2.00842H96.3908V32.8078H116.102V26.3399H104.707V2.00842Z",
    fill: "#00046A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3164 2.0083H9.8445L0.604736 32.8077H9.84461L11.0765 27.2639H19.0844L20.3164 32.8077H29.5563L20.3164 2.0083V2.0083ZM15.0805 8.78413L17.8525 21.4118L12.3085 21.4119L15.0805 8.78413Z",
    fill: "#00046A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7313 10.6322C44.0786 3.93876 32.1369 6.66009 32.0197 12.7882C30.2834 1.41823 44.0328 -0.95552 51.7305 2.62439C51.8677 4.44998 52.0051 6.41551 51.7313 10.6322V10.6322Z",
    fill: "#00046A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3821 14.2588C43.454 13.5063 40.6489 12.8216 40.6449 10.6294C40.6433 9.73403 41.0116 8.7618 42.7995 8.16833C36.6396 8.78429 34.5854 16.2775 41.3983 20.0018C42.5857 20.6509 44.6475 21.3394 44.6475 23.5678C44.6475 26.1708 41.7877 27.1117 39.9065 27.0719C36.7815 27.0062 34.269 25.9146 31.4037 23.8757V31.2676C34.7945 32.7272 40.3175 34.4107 45.8542 32.7079C50.3289 31.3317 54.1953 27.5755 54.1953 23.5676C54.1955 17.0461 48.5354 15.4897 45.3821 14.2588V14.2588Z",
    fill: "#00046A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_313_2854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.716,
    height: 32.596,
    fill: "white",
    transform: "translate(0.495605 0.955933)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsml);
export default __webpack_public_path__ + "static/media/asml.1e445636a7b64d8e5d2a9bec97d436ec.svg";
export { ForwardRef as ReactComponent };